import React, { memo, useCallback, useMemo } from 'react';
import { TableCell } from '@mui/material';
import _ from 'lodash';
import moment from 'moment';

import { DateTooltip } from 'ui/components/DateTooltip';
import { DateMessage } from 'ui/components/DateTooltip/types';
import { RenderCustomRowProps } from 'ui/components/Table/ItemsTable/types';
import { Vendor } from 'services/vendors';
import { useGetIntlDateFormatString } from 'helpers';

import { createActionBarOptions, VendorPageRowAction } from './consts';
import FBOMenuButton from 'ui/theme/components/FBOMenuButton/FBOMenuButton';

const VendorsRow: React.FC<RenderCustomRowProps<Vendor>> = (props) => {
  const { row, columns, onAction } = props;

  const intlFormatDate = useGetIntlDateFormatString();

  const handleAction = useCallback(
    (actionType: VendorPageRowAction) => {
      if (onAction) {
        onAction({ type: actionType, value: row });
      }
    },
    [onAction, row]
  );

  const tooltipDates: DateMessage[] = useMemo(
    () => [
      { date: row.dateCreated, message: 'Date Created' },
      { date: row.dateLastModified, message: 'Date Last Modified' },
    ],
    [row]
  );

  const dateValue: string = useMemo(() => {
    const dateField = columns.length > 1 ? columns[2].field! : null;
    const date = dateField ? _.get(row, dateField, null) : null;

    return date ? moment(date).format(intlFormatDate) : '';
  }, [columns, row, intlFormatDate]);

  return (
    <>
      <TableCell>{_.get(row, 'name')}</TableCell>

      {columns.length > 1 && (
        <>
          <TableCell>{_.get(row, 'paymentTerm.name' || '')}</TableCell>
          <DateTooltip values={tooltipDates}>
            <TableCell>{dateValue}</TableCell>
          </DateTooltip>
          <TableCell sx={{ padding: 0 }} align="center">
            <FBOMenuButton
              variant="tertiary"
              size="small"
              items={createActionBarOptions(handleAction, row)}
              data-qa="vendor-three-dot-menu"
            />
          </TableCell>
        </>
      )}
    </>
  );
};

export default memo(VendorsRow);
